import React from 'react';
import { Search } from './components/Search';
import { CustomerSelect } from './components/CustomerSelect';
import { RestaurantSelect } from './components/RestaurantSelect';
import { PriceInput } from './components/PriceInput';
import { ResetBtn } from './components/ResetBtn';
import { UnassignedCheckbox } from './components/UnassignedCheckbox';
import { SortBy } from './components/SortBy/SortBy';
import { AssignBtn } from './components/AssignBtn';
import style from './DishControlPanel.module.scss';

export const DishControlPanel: React.FC = () => {
	return (
		<div data-test="DishControlPanel">
			<Search />
			<div className={style.firstControlUnit}>
				<div className={style.flex}>
					<CustomerSelect />
					<RestaurantSelect />
				</div>
				<div className={style.flex}>
					<PriceInput />
					<ResetBtn />
				</div>
			</div>
			<div className={style.secondControlUnit}>
				<UnassignedCheckbox />
				<SortBy />
				<AssignBtn />
			</div>
		</div>
	);
};
